import React from 'react';

import {
  PageWrapper,
  OneHalfLayout,
  Flex,
  Placeholder,
  Panel
} from '@sopranodesign/pulse-components';
import { useQuery, useQueryClient, useMutation } from '@sopranodesign/pulse-hooks';
import { PolicyAccept, BackButton } from '@sopranodesign/pulse-channels';

import {
  InstagramSettings,
  SetupInstagramComponent
} from '../Components/index';
import { acceptPolicy as acceptPolicyApi } from '../api/index';

const InstagramLink = () => {
  const {
    data,
    isLoading,
    isSuccess
  } = useQuery({
    queryKey: [
      'instagram/settings'
    ]
  });

  const queryClient = useQueryClient();

  const { mutate: acceptPolicy } = useMutation({
    mutationFn: acceptPolicyApi,
    onSuccess: () => {
      queryClient.invalidateQueries('instagram/settings');
    }
  });

  const hasSettings = Boolean(data?.data.auth_token);

  const PolicyCheck = () => {
    if (!data.data.has_given_data_consent) {
      return (
        <PolicyAccept
          handlePolicyAccept={acceptPolicy}
          policyUrl="https://developers.facebook.com/devpolicy/"
        />
      );
    }
    if (!hasSettings) {
      return <SetupInstagramComponent data-testid="instagram-settings" />;
    }

    return <InstagramSettings settings={data.data} />;
  };

  return (
    <PageWrapper
      center
      half
      header="Instagram"
      prevAction={<BackButton to="/channels" />}>
      <Flex col center>
        <OneHalfLayout>
          {isLoading && (
            <Panel>
              <Placeholder items={1} subitems={3} center />
            </Panel>
          )}
          {isSuccess && <PolicyCheck />}
        </OneHalfLayout>
      </Flex>
    </PageWrapper>
  );
};

export default InstagramLink;
